export default __webpack_public_path__ + "static/media/logoProducthouse.1de154fc.svg";